import * as paths from './constants';
import {
  NAVIGATE_TO_BD_REVIEW,
  NAVIGATE_TO_BD,
  ROUTE_SIGNIFICANT_PEOPLE_PAGE
} from '../utils/constants';

export const previousRoutePaths = {
  [paths.ROUTE_PERSONAL_INFO_PAGE]: paths.ROUTE_INITIAL_QUESTION_PAGE,
  [paths.ROUTE_ADDITIONAL_PRODUCT_PAGE]: paths.ROUTE_ACCOUNT_DETAILS_PAGE,
  [paths.ROUTE_SIGNATORIES_AND_SHAREHOLDERS_PAGE]: paths.ROUTE_ADDITIONAL_PRODUCT_PAGE,
  [paths.ROUTE_BUSINESS_MANDATE_PAGE]: paths.ROUTE_SIGNIFICANT_PEOPLE_PAGE,
  [paths.ROUTE_ACCOUNT_DETAILS_PAGE]: NAVIGATE_TO_BD,
  [paths.ROUTE_REVIEW_PAGE]: NAVIGATE_TO_BD_REVIEW,
  [paths.ROUTE_PERSONAL_DETAILS_PAGE]: ROUTE_SIGNIFICANT_PEOPLE_PAGE,
  [paths.ROUTE_BUSINESS_TYPE_PAGE]: paths.ROUTE_PERSONAL_INFO_PAGE,
  [paths.ROUTE_OLD_ACCOUNT_DETAILS_PAGE]: paths.ROUTE_SWITCH_BUSINESS_PAGE,
  [paths.ROUTE_OLD_ADD_SIGNATORY_PAGE]: paths.ROUTE_OLD_SIGNATORIES_PAGE,
  [paths.ROUTE_OLD_SIGNATORIES_PAGE]: paths.ROUTE_OLD_ACCOUNT_DETAILS_PAGE,
  [paths.ROUTE_SWITCH_BUSINESS_PAGE]: paths.ROUTE_ALMOST_THERE_PAGE,
  [paths.ROUTE_SWITCH_DATE_PAGE]: paths.ROUTE_OLD_ACCOUNT_DETAILS_PAGE
};
